"use strict";
exports.__esModule = true;
exports.AuthContext = exports.AuthProvider = exports.useAuth = void 0;
var AuthProvider_1 = require("../provider/AuthProvider");
exports.AuthContext = AuthProvider_1.AuthContext;
exports.AuthProvider = AuthProvider_1.AuthProvider;
var React = require("react");
var useAuth = function () {
    return React.useContext(AuthProvider_1.AuthContext);
};
exports.useAuth = useAuth;
